var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: { size: "large", closable: true, destroyOnClose: true },
      on: { open: _vm.openModalHandle },
    },
    [
      _vm.isHKlandUser && _vm.shouldShowReceivers
        ? _c("CommentsPreviewBodyRecipients", {
            attrs: {
              receivers: _vm.emailReceivers,
              subject: _vm.letterSubject,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "GreenOperationPreviewBody",
        {
          attrs: {
            comments: _vm.previewData.comments,
            greeting: _vm.$t("tenancy.greenOperation.letters.toTenants", [
              _vm.companyName,
            ]),
          },
        },
        [
          _vm.isTenant
            ? _c(
                "div",
                { attrs: { slot: "recipientsSlot" }, slot: "recipientsSlot" },
                [
                  _c("div", [
                    _c("span", { staticClass: "small-mgn-right" }, [
                      _vm._v(_vm._s(_vm.$t("to")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.firstSendReceivers.to))]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "small-mgn-right" }, [
                      _vm._v(_vm._s(_vm.$t("cc")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.firstSendReceivers.cc))]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "location section-mgn-btm",
              attrs: { slot: "additionalInfoSlot" },
              slot: "additionalInfoSlot",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("tenancy.greenOperation.letters.recogScheme")) +
                  "\n    "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("TenantSubmissionDocuments", {
        attrs: {
          files: _vm.files,
          sourceId: (_vm.previewData || {}).id || "",
          canEdit: false,
        },
        on: {
          "update:files": function ($event) {
            _vm.files = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.isHKlandUser
        ? _c("SendHistory", { attrs: { histories: _vm.sendHistories } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isHKlandUser
        ? _c("ReviewerHistory", {
            attrs: { histories: _vm.reviewHistories, showPM: false },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [_c("div")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }